import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { AccountLevelResultsPage } from './AccountLevelResultsPage';
import { AccountLevelGate } from './AccountLevelGate';
export const AccountLevelGatePages = _ref => {
  let {
    handlers,
    hideBackButton
  } = _ref;
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.ModalsProvider, null, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: "/results",
    render: () => /*#__PURE__*/React.createElement(AccountLevelResultsPage, {
      handlers: handlers
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/",
    render: () => /*#__PURE__*/React.createElement(AccountLevelGate, {
      handlers: handlers,
      hideBackButton: hideBackButton
    })
  }))));
};
//# sourceMappingURL=AccountLevelGatePages.js.map